import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

type Props = {
  content: CmsApiDocument;
};

export function getIsContentFullWidthLayout({ content }: Props) {
  return content.layout === 'FULL_WIDTH';
}
